export enum Product {
  IchraId = 1,
  QsehraId = 2,
  GroupHraId = 3,
}
export enum ProductAllowance {
  Family = 0,
  Category = 1,
}
